import { useConfigStore } from '@/stores';
import clsx from 'clsx';
import styles from './styles.module.scss';

interface EventPageHeaderProps {
    title: string;
    description: string;
    isHorizontal: boolean;
    tabIndex?: number;
}

export default function EventPageHeader({ title, description, isHorizontal, tabIndex = 1 }: EventPageHeaderProps) {
    const screenMode = useConfigStore((state) => state.config.ui.screenMode);
    const isHalfScreen = screenMode === 'split';

    const headerClassname = clsx(
        styles.header,
        isHorizontal ? styles['header--horizontal'] : styles['header--vertical'],
        isHalfScreen && !isHorizontal && styles['header--verticalHalf'],
        isHalfScreen && isHorizontal && styles['header--horizontalHalf']
    );

    return (
        <header className={headerClassname}>
            <div
                className={styles['header__content']}
                tabIndex={tabIndex}
                data-region-nav
                data-region-order={tabIndex}
                data-interactive
                aria-label={`${title} ${description}`}
            >
                <h1 className={styles.title}>{title}</h1>
                <p className={styles.description}>{description}</p>
            </div>
        </header>
    );
}
